export default __webpack_public_path__ + "static/perfect-pair.light-a16a41c665a1b77f1079282c274bb5fb12b2b6484ac0ce6720f21fa87b4a1031.png";